/**
 * @generated SignedSource<<7b7da27c66f4168c41c6ce09d078f1a6>>
 * @relayHash d171b6a6e2fa5fe774746654c415a17e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6829238bbd8ffb42d9e14006fe44b9c379b7e88b65fbca1173a13c564c49831b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { pageLayout_projectsDirectoryLayout_RootQuery } from './pageLayout_projectsDirectoryLayout_RootQuery.graphql';

const node: PreloadableConcreteRequest<pageLayout_projectsDirectoryLayout_RootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6829238bbd8ffb42d9e14006fe44b9c379b7e88b65fbca1173a13c564c49831b",
    "metadata": {},
    "name": "pageLayout_projectsDirectoryLayout_RootQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
